import { useCircleV4 } from "@/react/hooks/useCircleV4";

import type { MemberCardWithConnectionProps } from "./MemberCardWithConnectionCompass";
import { MemberCardWithConnection as MemberCardWithConnectionCompass } from "./MemberCardWithConnectionCompass";
import { MemberCardWithConnection as MemberCardWithConnectionUiKit } from "./MemberCardWithConnectionUiKit";

export const MemberCardWithConnection = (
  props: MemberCardWithConnectionProps,
) => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return <MemberCardWithConnectionCompass {...props} />;
  }

  return <MemberCardWithConnectionUiKit {...props} />;
};
